import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';

@Injectable({
   providedIn: 'root'
})
export class ValidationbirthdayService {

   constructor () { }

   private withBirthday$_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public withBirthday: Observable<boolean> = this.withBirthday$_.asObservable();
  
   private isModule_: boolean = false; 

   get birthday (): boolean {
      return this.withBirthday$_.value;
   }
  
   set birthday (value: boolean) {
      this.withBirthday$_.next(value);
   }

   set isModule (value: boolean) {
      this.isModule_ = value; 
   }

   get isModule (): boolean {
      return this.isModule_; 
   }
}
